var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_levitationButton", attrs: { id: "_levitationButton" } },
    [
      _c(
        "div",
        { staticClass: "_contentRootBox", style: _vm.getContentRootBoxStyle() },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isMove,
                  expression: "!isMove"
                }
              ],
              staticClass: "_contentBox",
              style: Object.assign(
                {},
                {
                  "--translateY": !_vm.mShow
                    ? "0"
                    : _vm.toTop
                    ? "-100%"
                    : "100%"
                },
                _vm.contentStyle
              )
            },
            [_vm._t("default")],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "_lvBt", style: _vm.lvBtStyle },
        [
          _c("div", {
            staticStyle: {
              position: "absolute",
              "z-index": "1",
              width: "100%",
              height: "100%"
            },
            on: {
              mousedown: function($event) {
                $event.stopPropagation()
                return _vm.mousedown.apply(null, arguments)
              },
              click: function($event) {
                $event.stopPropagation()
                return _vm.setShowContent.apply(null, arguments)
              }
            }
          }),
          _vm._v(" "),
          _vm._t(
            "lvBt",
            function() {
              return [
                _vm._v(
                  "\n      " + _vm._s(_vm.mShow ? "展开" : "收起") + "\n    "
                )
              ]
            },
            { status: !_vm.mShow }
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d4614ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d4614ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/component/LevitationButton.vue
// module id = null
// module chunks = 